export default "__VITE_ASSET__2fa8153d__"